import { useGalleryState } from '@/composables/useGalleryState'

const { gallery, activeSlide } = useGalleryState()

export function useGalleryHelpers() {
  const findSlideByDamId = (damId: string) => {
    const found = gallery.value.images.findIndex((image) => image.dam.damId === damId)
    if (found > -1) return found
    return 0
  }

  const updateBrowserUrl = (slide: number) => {
    const imageDocId = gallery.value.images[slide].dam.damId
    if (history.pushState) {
      history.pushState(null, '', '#' + imageDocId)
      return
    }
    location.hash = '#' + imageDocId
  }

  const resolveActiveSlide = (): number => {
    const damIdFromHash = location.hash.substring(1)

    if (damIdFromHash.trim().length > 0) {
      activeSlide.value = findSlideByDamId(damIdFromHash)
      return activeSlide.value
    }
    updateBrowserUrl(0)
    return 0
  }

  return {
    findSlideByDamId,
    updateBrowserUrl,
    resolveActiveSlide,
  }
}
